// src/utils/abort-error.ts
var AbortError = class _AbortError extends Error {
  constructor(message) {
    super(message);
    Object.setPrototypeOf(this, _AbortError.prototype);
    this.name = "AbortError";
  }
};

export {
  AbortError
};
